
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"30","viewBox":"0 0 30 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M0 0h30v20H0V0z","fill":"#000"}}),_c('path',{attrs:{"d":"M0 6.667h30V20H0V6.667z","fill":"#D00"}}),_c('path',{attrs:{"d":"M0 13.333h30V20H0v-6.667z","fill":"#FFCE00"}})])
          )
        }
      }
    